export default __webpack_public_path__ + "static/media/data1.b4d53395.svg";